export const TiharDates = {
  start_date: '2026-11-07 00:00:00',
  end_date: '2026-11-11 00:00:00',
  dates: [
    { eng_label: 'Kaag Tihar', nep_label: 'काग तिहार', day: 1 },
    { eng_label: 'Kukur Tihar', nep_label: 'कुकुर तिहार', day: 2 },
    { eng_label: 'Laxmi Pooja', nep_label: 'लक्ष्मी पुजा', day: 2 },
    { eng_label: 'Gaai Puja', nep_label: 'गाई पूजा', day: 3 },
    { eng_label: 'Gobardan Puja', nep_label: 'गोवर्धन पूजा', day: 4 },
    { eng_label: 'Mha Puja', nep_label: 'म्हपूजा', day: 4 },
    { eng_label: 'Bhai Tika', nep_label: 'भाइटीका', day: 5 },
  ],
}

export const DashainDates = {
  start_date: '2026-10-11 00:00:00',
  end_date: '2026-10-25 00:00:00',
  dates: [
    { eng_label: 'Ghatasthapana', nep_label: 'घटस्थापना', day: 1 },
    { eng_label: 'Fulpati', nep_label: 'फूलपाती', day: 7 },
    { eng_label: 'Maha astami', nep_label: 'महाअष्टमी', day: 8 },
    { eng_label: 'Maha Nawami', nep_label: 'महानवमी', day: 10 },
    { eng_label: 'Bijaya Dashami', nep_label: 'विजया दशमी', day: 11 },
    { eng_label: 'Papakunsa Ekadashi', nep_label: 'पापांकुशा एकादशी', day: 12 },
    { eng_label: 'Kojagrat Poornima', nep_label: 'कोजाग्रत पूर्णिमा', day: 15 },
  ],
}

export const DashainMessages = {
  nepEffect: 'विजया दशमी एवम दिपावली २०८३ को हार्दिक मंङगलमय शुभकामना!!!',
  engEffect: 'Wish you a very Happy Dashain and Tihar!!!',
}

export const TiharMessage = {
  nepEffect: 'शुभ दिपावलीको हार्दिक मंङगलमय शुभकामना!!!',
  engEffect: 'Happy Deepawali!!!',
}

export const NepaliYear = "२०८३"
